<template>
  <div class="produts">
    <div class="produts-title">
      <custom-breadcrumb/>
    </div>
    <div class="produts-top">
      <div class="produts-top-tabs">
        <div :class="{isActive:tabType=='All'}" @click="tabSwitch('All')">All</div>
        <div :class="{isActive:tabType=='Active'}" type="Active" @click="tabSwitch('Active')">Active</div>
        <div :class="{isActive:tabType=='Inactive'}" @click="tabSwitch('Inactive')">Inactive</div>
        <div :class="{isActive:tabType=='InReview'}" @click="tabSwitch('InReview')">In Review</div>
      </div>
      <div class="btn-product" v-if="brandManagementMode!==3" >
          <div @click="$refs['importPro'].show()">Import</div>
          <div @click="$router.push({path:'CreateSpu'})">Add Products</div>
      </div>

    </div>
    <div class="produts-search">
      <el-form :inline="true" :model="produtsForm">
        <el-form-item>
          <el-select placeholder="Category" v-model="produtsForm.categoryId" clearable @change="search(false)">
            <el-option
              v-for="(item,index) in categorysList"
              :key="index"
              :label="item.cateName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="produtsForm.time"
            value-format="yyyy-MM-dd"
            format="MM.dd.yyyy"
            type="date"
            placeholder="Last Update"
            @change="search(false)"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="Product name / Brands/Product ID" v-model="produtsForm.keyWords"
                    class="input-with-select" style="width: 550px;">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <div class="produts-search-button" slot="append" @click="search(false)">
              Search
            </div>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="products-content">
      <el-table
        :data="tableData"
        height="calc(100vh - 350px)"
        stripe
        style="width: 100%"
      >
        <el-table-column label="Name" min-width="350">
          <template slot-scope="scope">
            <div class="table-name">
              <div class="table-img"><img :src="scope.row.imgUrl" alt=""></div>
              <div>
                {{ scope.row.title }}
                <div class="review-mark" v-if="scope.row['reviewStatus']==2">In Review</div>
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column
          label="Variations"
          prop="variations"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="category"
          min-width="100"
          label="Category"
        >
        </el-table-column>

        <template v-if="brandManagementMode==2 || brandMode=='4'">
          <el-table-column
            min-width="120"
            label="Cost Price($)"
          >
            <template slot-scope="scope">
              <div>$ {{ scope.row.costRange }}</div>
            </template>
          </el-table-column>
        </template>
        <!-- 入驻模式start -->
        <template v-if="(brandManagementMode==1 || brandMode=='4')">
          <el-table-column
            min-width="120"
            label="FOB Price($)"
          >
            <template slot-scope="scope">
              <div>  {{ scope.row.shippingCountry ==='China' ? '$'+scope.row.fobRange : '——' }}</div>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            min-width="120"-->
          <!--            label="CIF Price($)"-->
          <!--          >-->
          <!--            <template slot-scope="scope">-->
          <!--              <div>$ {{scope.row.cifRange}}</div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            min-width="160"
            label="Wholesale Price($)"
          >
            <template slot-scope="scope">
              <div>$ {{ scope.row.wholesalePrice }}</div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="180"
            label="Suggest Retail Price($)"
          >
            <template slot-scope="scope">
              <div>$ {{ scope.row.suggestRetailPriceRange }}</div>
            </template>
          </el-table-column>
          <el-table-column
            min-width="160"
            label="Procurement Price"
          >
            <template slot-scope="scope">
              <div> {{ scope.row.procurementPriceRange ? '$' + scope.row.procurementPriceRange : '——' }}</div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="210"
            label="Wholesale Settlement Price"
          >
            <template slot-scope="scope">
              <div> {{ scope.row.kaSettlementPriceRange ? '$' + scope.row.kaSettlementPriceRange : '——' }}</div>
            </template>
          </el-table-column>

          <el-table-column
            min-width="180"
            label="Shipping from Country"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.shippingCountry ? scope.row.shippingCountry : '——' }}</div>
            </template>
          </el-table-column>
        </template>
        <!-- 入驻模式end -->

        <el-table-column
          min-width="120"
          prop="brandName"
          label="Brand Name"
        >
        </el-table-column>
        <el-table-column
          min-width="120"
          prop="updateTime"
          label="Last Update"
        >
        </el-table-column>

        <el-table-column
          min-width="150"
          label="Product Link"
        >
          <template slot-scope="scope" >
            <span @click="openUrl(scope)" class="table-url">View</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Status"
          width="150"
        >
          <template slot-scope="scope">
            <div class="cust-active">
              <el-select v-model="scope.row.goodsStatus" :class="{'normal':scope.row.goodsStatus=='1'}"
                         @change="(v)=>changeGoodsStatus(v,scope.row)" placeholder="Please Select">
                <el-option
                  v-for="item in goodsStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Action"
        >
          <template slot-scope="scope">
            <i class="el-icon-edit-outline" @click="edit(scope.row)"></i>
          </template>
        </el-table-column>

        <!-- inreview页签需要显示以下 -->
        <template v-if="brandMode=='4'">
          <el-table-column
            width="190"
            label="Review">
            <template slot-scope="scope">
              <div class="review" v-if="scope.row['reviewStatus']==2">
                <span @click="review('p',scope.row['id'])">Pass</span>
                <span @click="review('r',scope.row['id'])">Reject</span>
              </div>
              <span v-else-if="scope.row['reviewStatus']==1">Pass</span>
              <span v-else-if="scope.row['reviewStatus']==0">Reject</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Reviewer">
            <template slot-scope="scope">
              {{ scope.row['approvedBy'] }}
            </template>
          </el-table-column>
          <el-table-column
            width="190"
            label="Last Modified By">
            <template slot-scope="scope">
              {{ scope.row['lastModifyBy'] }}
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <pagination
      :currentPage="paging.current"
      :total="paging.total"
      :pageSize="paging.size"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <import-products ref="importPro"></import-products>

  </div>

</template>

<script>
import Pagination from '../components/pagination.vue'
import importProducts from './import-products'
import {getAction, putAction} from '@/api/manage.js'
import qs from 'qs'
import Vue from 'vue'
import CustomBreadcrumb from '../components/custom-breadcrumb'

export default {
  name: 'procurement-products',
  components: {CustomBreadcrumb, Pagination, importProducts},
  data() {
    return {
      tabType: 'All',
      produtsForm: {
        pageSize: 20,
        currentPage: 1
      },
      categorysList: [],
      tableData: [],
      paging: {},
      brandMode: Vue.ls.get('userInfo').model, // 账号类型  4运营者账号
      brandManagementMode: Vue.ls.get('userInfo').supplierManagementModel, // 供应商经营模式1入驻 2自营 3运营
      goodsStatusOptions: [{
        value: '1',
        label: 'Active'
      }, {
        value: '0',
        label: 'Inactive'
      }]
    }
  },
  methods: {
    edit(row) {
      const userInfo = Vue.ls.get('userInfo')
      // 只有批发商跳转新页面，否则跳转当前页面
      if (userInfo.userSource === 3) {
        window.open(window.location.origin + '/menu/wholesale-spu-detail?goodsId=' + row.id)
      } else {
        window.open(window.location.origin + '/menu/spuDetails?goodsId=' + row.id)
      }
      // this.$router.push({
      //   path: 'spuDetails',
      //   query: {
      //     goodsId: row.id
      //   }
      // })
    },
    tabSwitch(type) {
      this.tabType = type
      this.produtsForm = {
        pageSize: 20,
        currentPage: 1
      }
      this.search(false)
    },
    async search(isPage) {
      //add by cpgu 如果操作的不是分页，则重置分页 2023/11/30  begin
      if (!isPage) {
        this.produtsForm.pageSize = 20;
        this.produtsForm.currentPage = 1;
      }
      //end by cpgu

      if (this.produtsForm.time) {
        this.produtsForm.lastUpdateStartTime = this.produtsForm.time + ' 00:00:00'
        this.produtsForm.lastUpdateEndTime = this.produtsForm.time + ' 23:59:59'
      } else {
        this.produtsForm.lastUpdateStartTime = ''
        this.produtsForm.lastUpdateEndTime = ''
      }
      switch (this.tabType) {
        case 'All':
          this.produtsForm.goodsStatus = ''
          break
        case 'Active':
          this.produtsForm.goodsStatus = '1'
          break
        case 'Inactive':
          this.produtsForm.goodsStatus = '0'
          break
        case 'InReview':
          this.produtsForm.inReview = '2'
          break
        default:
          this.produtsForm.goodsStatus = ''
          this.produtsForm.inReview = ''
      }
      // const supplierId = this.$ls.get('userInfo').id
      // /product/api/v0.2/suppliers/{supplierId}/products
      let data = await getAction(`/sp/suppliers/product/goods?${qs.stringify(this.produtsForm)}`)
      // console.log(data)
      if (data.code === 200) {
        this.tableData = data.result.records
        this.paging = data.result
      }
      // console.log(this.tableData)
    },
    handleSizeChange(val) {
      this.produtsForm.pageSize = val
      this.produtsForm.currentPage = 1
      this.search(true)
    },
    handleCurrentChange(val) {
      this.produtsForm.currentPage = val
      this.search(true)
    },
    openUrl(obj) {
      let env = process.env.NODE_ENV
      let url = ''
      env === 'test' ? url = 'https://test-thalesmart-manage-ui2.hupofintech.com/product'
        : url = 'https://www.shopvidi.com/product'
      window.open(url + obj.row.seoUrl)
    },
    async review(type, goodsId) {
      let status = (type == 'p') ? 1 : 0
      let res = await putAction(`/v0.2/brand/review/goods/${goodsId}/status/${status}`)
      if (res['code'] == 200) {
        this.$message.success(res.message)
        await getAction(`/es/createGoods?goodsId=${goodsId}`)
        if (res.result && res.result.length > 0) {
          putAction('/v0.2/invoices/batch-invoice', res.result).then(response => {})
        }
        await this.search(false)
      } else {
        this.$message.warning(res.message)
      }
    },
    async changeGoodsStatus(val, obj) {
      let res = await putAction(`/sp/suppliers/products/goods/${obj.id}/status?status=` + val)
      if (res['code'] == 200) {
        await getAction(`/es/createGoods?goodsId=${obj.id}`)
        this.$message.success(res.message)
      }
    }
  },

  async created() {
    let categorys = await getAction('/sp/suppliers/categorys')
    if (categorys.code === 200) {
      this.categorysList = categorys.result
    }
   await this.search(false)
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-input-group__append {
  background: #000000;
  color: #ffffff;

  :hover {
    cursor: pointer;
  }
}

/deep/ .cell {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  color: #000000;
}

.table-name {
  display: flex;

  div:nth-child(2) {
    padding-left: 10px;
  }

}

.review-mark {
  width: 120px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #C3824B;
  border: 1px solid #E1E1E1;
  background: #E1E1E1;
  border-radius: 5px;
}

.table-img {
  max-width: 80px;
  max-height: 80px;
  border: 1px solid #262B2F;

  img {
    width: 100%;
    height: 100%;
  }

}

.produts {
  .produts-title {
    font-size: 14px;
    font-weight: 600;
    color: #262B2F;
    margin: 10px 30px 20px 0px !important;
    // padding-bottom: 20px;
  }

  // padding-left: 31px;
  // padding-right: 33px;
}

.produts-top {
  width: 100%;
  padding-top: 10px;
  border-bottom: 1px solid #E1E1E1;
  position: relative;

  .produts-top-tabs {
    width: 348px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    color: #5D5D5D;

    div {
      width: 116px;
      text-align: center;
      cursor: pointer;
    }

    .isActive {
      padding-bottom: 17px;
      border-bottom: 2px solid #262B2F;
      font-size: 16px;
      font-family: Graphik;
      font-weight: 500;
    }

  }

  .btn-product {
    position: absolute;
    right: 0px;
    top: 0px;
    display: flex;
    div{
      margin-left: 10px;
      box-sizing: border-box;
      background: #000000;
      color: #ffffff;
      width: 130px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      border-radius: 3px;
    }

  }
}

.produts-search {
  padding-top: 20px;
}

.table-url {
  cursor: pointer;
  text-decoration: underline;
}

.edit {
  width: 80px;
  height: 40px;
  line-height: 40px;
  background: #000000;
  color: #ffffff;
  text-align: center;
  border-radius: 12px;
  cursor: pointer;
}

// .produts-search-button{
//   background: #000000;
// }

.cust-active {
  /deep/ .el-select {
    width: 90px;
    height: 40px;
    opacity: 1;
    border-radius: 20px;
  }

  /deep/ .el-input__inner {
    border-radius: 20px !important;
  }

  .normal {
    /deep/ .el-input__inner {
      background: #262613 !important;
      color: #ffffff;
    }
  }

  /deep/ .el-dropdown {
    height: 20px;
    background: #f4f4f4 !important;
    border: 1px solid #e1e1e1;
    border-radius: 20px;
    line-height: 40px;
  }
}

.review {
  span {
    width: 80px;
    border: 20px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border: 1px #262613 solid;
    border-radius: 20px;
    display: inline-block;
    cursor: pointer;

  }
}

</style>



// WEBPACK FOOTER //
// src/pages/produts/index.vue